import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { useCallback } from 'react';
import { Formik } from 'formik';
import * as yup from 'yup';
import { useToast } from '@sketch/toasts';
import { Panel, Form, Input, Button } from '@sketch/components';
import { HelpNote } from './HelpNote.js';
import { Title, Description, FormContainer, Note, Paragraph, StyledFakeLinkButton } from '../SignInToLinkAccountView.styles.js';
import { useValidateMfaRecoveryCodeMutation } from '@sketch/gql-types';

const INITIAL_VALUES = {
    recoveryCode: '',
};
const VALIDATION_SCHEMA = yup.object().shape({
    recoveryCode: yup.string().trim().required('Enter a recovery code'),
});
/**
 * Renders the UI that allows the user to enter the recovery code
 */
const RecoveryCode = ({ onCompleted, mfaToken, toggleInterface, }) => {
    const { showToast } = useToast();
    // Recovery Code Validation
    const [validateRecoveryCode, { loading },] = useValidateMfaRecoveryCodeMutation({
        onCompleted,
        onError: error => {
            // TODO: Improve returned error types from local resolvers
            // https://github.com/sketch-hq/Cloud/issues/11366
            const mfaError = error.message;
            showToast(mfaError.message, 'negative');
        },
    });
    const handleSubmitRecoveryCode = useCallback((values, actions) => {
        validateRecoveryCode({
            variables: {
                token: mfaToken,
                recoveryCode: values.recoveryCode,
            },
        });
        actions.setSubmitting(false);
    }, [mfaToken, validateRecoveryCode]);
    return (jsxs(Fragment, { children: [jsx(Title, { children: "Enter Recovery Code" }), jsxs(Panel.Body, { children: [jsx(Description, { children: "Can\u2019t access your authenticator app? Enter a recovery code instead." }), jsxs(FormContainer, { children: [jsx(Formik, Object.assign({ initialValues: INITIAL_VALUES, onSubmit: handleSubmitRecoveryCode, validationSchema: VALIDATION_SCHEMA }, { children: ({ values, handleChange, errors, touched, isSubmitting }) => (jsxs(Form, { children: [jsx(Form.Field, Object.assign({ name: "text", errorText: touched.recoveryCode ? errors.recoveryCode : undefined }, { children: jsx(Input, { name: "recoveryCode", placeholder: "Enter recovery code", type: "text", value: values.recoveryCode, onChange: handleChange }) })), jsx(Button, Object.assign({ type: "submit", variant: "primary-untinted", loading: isSubmitting || loading, fill: true, size: "40" }, { children: "Submit" }))] })) })), jsx(Note, { children: jsxs(Paragraph, { children: ["Authenticator app working again?", ' ', jsx(StyledFakeLinkButton, Object.assign({ variant: "tertiary", onClick: toggleInterface, isUnderlined: true }, { children: "Enter verification code" })), jsx("br", {}), jsx(HelpNote, {})] }) })] })] })] }));
};

export { RecoveryCode as default };
